export default __webpack_public_path__ + "static/media/tui.e48773cb.png";